import { Controller } from "@hotwired/stimulus"

// Delegation hovercard for containers that hold plain <a href="/articles/:id"> links.
// Primary use: moment content, where WikiLinkResolver outputs bare <a href> tags rather than
// ActionText attachments. Attach data-controller="article-link-hovercard" to any wrapper element.
export default class extends Controller {
  connect() {
    this._showTimer = null
    this._hideTimer = null
    this._card = null
    this._activeLink = null
    this._onMouseover = this._handleMouseover.bind(this)
    this._onMouseout  = this._handleMouseout.bind(this)
    this.element.addEventListener("mouseover", this._onMouseover)
    this.element.addEventListener("mouseout",  this._onMouseout)
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this._onMouseover)
    this.element.removeEventListener("mouseout",  this._onMouseout)
    clearTimeout(this._showTimer)
    clearTimeout(this._hideTimer)
    if (this._card) {
      this._card.remove()
      this._card = null
    }
  }

  _handleMouseover(event) {
    const link = event.target.closest("a[href]")
    if (!link || !this._isArticleLink(link)) return
    if (this._activeLink === link) {
      clearTimeout(this._hideTimer)
      this._hideTimer = null
      if (this._card) this._card.style.display = ""
      return
    }
    // Different link: dismiss current card and start fresh
    this._dismiss()
    this._activeLink = link
    this._showTimer = setTimeout(() => {
      this._showTimer = null
      this._fetch(link)
    }, 200)
  }

  _handleMouseout(event) {
    const link = event.target.closest("a[href]")
    if (!link || !this._isArticleLink(link)) return
    if (link.contains(event.relatedTarget)) return
    clearTimeout(this._showTimer)
    this._showTimer = null
    this._startHide()
  }

  _isArticleLink(el) {
    try {
      const url = new URL(el.href, window.location.origin)
      return /^\/articles\/\d+$/.test(url.pathname)
    } catch { return false }
  }

  _articleId(el) {
    try {
      const url = new URL(el.href, window.location.origin)
      const m = url.pathname.match(/\/articles\/(\d+)$/)
      return m ? m[1] : null
    } catch { return null }
  }

  _fetch(link) {
    const id = this._articleId(link)
    if (!id) return
    fetch(`/articles/${id}/hovercard`)
      .then(r => r.text())
      .then(html => {
        if (this._activeLink !== link) return  // user moved on
        const tmp = document.createElement("div")
        tmp.innerHTML = html
        const card = tmp.firstElementChild
        if (!card) return
        document.body.appendChild(card)
        this._card = card
        this._card.addEventListener("mouseenter", () => {
          clearTimeout(this._hideTimer)
          this._hideTimer = null
        })
        this._card.addEventListener("mouseleave", () => this._startHide())
        this._position(link)
      })
  }

  _position(link) {
    if (!this._card) return
    const rect = link.getBoundingClientRect()
    const cardW = 384
    const left = Math.max(8, Math.min(rect.left, window.innerWidth - cardW - 8))
    this._card.style.left = `${left}px`
    if (rect.bottom + 260 > window.innerHeight && rect.top > 260) {
      this._card.style.top = "auto"
      this._card.style.bottom = `${window.innerHeight - rect.top + 4}px`
    } else {
      this._card.style.top = `${rect.bottom + 4}px`
      this._card.style.bottom = "auto"
    }
    this._card.style.display = ""
  }

  _startHide() {
    this._hideTimer = setTimeout(() => {
      this._hideTimer = null
      this._dismiss()
    }, 200)
  }

  _dismiss() {
    clearTimeout(this._showTimer)
    this._showTimer = null
    this._activeLink = null
    if (this._card) {
      this._card.remove()
      this._card = null
    }
  }
}
